// extracted by mini-css-extract-plugin
export default {"bankBic":"bank_bankBic__QKDa-","bankIban":"bank_bankIban__6vYJu"};